<div class="modal-header">{{keyword.it}}</div>
<div class="modal-body">
    <faq [faqs]="faqs"></faq>
</div>
